import Tabs from './tabs';
import Card from './card';
import Link from './link';
import Alert from './alert';
import Input from './input';
import Modal from './modal';
import Button from './button';
import Select from './select';
import Header from './header';
import PinInput from './pinInput';
import Checkbox from './checkbox';
import RadioButtonGroup from './radioButtonGroup';
import LateralMenu from './lateralMenu';

export default {
  Tabs,
  Card,
  Link,
  Alert,
  Modal,
  Input,
  Header,
  Select,
  Button,
  Checkbox,
  PinInput,
  LateralMenu,
  RadioButtonGroup,
};
